import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  EmailField,
  useTranslate,
  usePermissions,
  EditButton,
} from 'react-admin';
import ListActions from '../../components/ListActions';
import ClientsFilter from '../../components/ClientsFilter';
import TourUsers from './TourUsers';

const UserList = (props) => {
  const translate = useTranslate();
  const { permissions } = usePermissions();
  return (
    <List
      {...props}
      actions={
        permissions === 'ADMIN' ? (
          <ListActions {...props} tourConfig={TourUsers} hideFilters />
        ) : null
      }
      filters={<ClientsFilter />}
    >
      <Datagrid rowClick="edit">
        <TextField source="id" />
        <TextField
          label={translate('custom.users.username')}
          source="username"
        />
        <EmailField label={translate('custom.users.email')} source="email" />
        <TextField label={translate('custom.general.status')} source="status" />
        <TextField label={translate('custom.users.role')} source="role" />
        <TextField
          label={translate('custom.general.createdAt')}
          source="createdAt"
        />
        <TextField
          label={translate('custom.general.updatedAt')}
          source="updatedAt"
        />
        <EditButton data-testid="clients-edit" />
      </Datagrid>
    </List>
  );
};

export default UserList;
